import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selfserviceDashboard } from "../../redux/actions";
import { capitalizeFirstLetter } from "../../utils/prices";
const Dashboard = () => {
  const [dashboard, setdashboard] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await selfserviceDashboard();
        setdashboard(data || []); // Ensure orders exist
      } catch (err) {
        setError(err.message);
      }
    };
    fetchOrders();
  }, []);

  const orders = dashboard?.page?.data?.orders || [];
  const special_products =
    dashboard?.page?.data?.products_without_special_price || [];

  const navigate = useNavigate();
  const handleRedirect = (id) => {
    navigate("/self-service/track-orders", { state: { action: id } }); // Pass the id in the URL
  };

  const user = useSelector((state) => state?.user_data);
  const limit = user?.user_data?.company?.credit_limit || 0;
  const usedSoFar = user?.user_data?.company?.credit_used;
  let progress = (usedSoFar / limit) * 100;
  if (progress >= 100) progress = 100;
  if (progress < 0) progress = 0;

  const currency = user?.user_data?.company?.currency?.value || "AED";
  return (
    <section className="hot-deals pt-20">
      {/* component 1 about us*/}
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h2 className="mb-0 text-blue">
              HELLO{" "}
              {user?.user_data
                ? `Welcome, ${user.user_data?.name}!`
                : "Please log in."}
            </h2>
          </div>
        </div>
      </div>

      <div className="container container-lg ">
        <div className="row gy-4">
          {/* grid for orders */}
          <div className="col-sm-6">
            <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
              <div className="py-xl-4">
                <h4 className="text-blue ack mb-8">Active Orders</h4>
                <hr></hr>
                {orders.length === 0 && (
                  <p>There are no orders to display yet!</p>
                )}
                {orders &&
                  orders.length > 0 &&
                  orders.map((datas, index) => (
                    <div key={index}>
                      <div className="flex-align gap-8 d-flex justify-content-between w-100 p-22">
                        <span className="text-sm text-white">
                          <p className="text-blue">
                            <b>
                              Order {console.log(datas)}
                              {new Date(datas?.created_at)
                                .toLocaleDateString("en-GB")
                                .replace(/\//g, ".")}
                            </b>
                          </p>
                          <p className="text-black">
                            Delivery to {datas?.location?.name}
                          </p>
                        </span>
                        <span className="text-sm text-main-two-600">
                          <i
                            key={datas.id}
                            onClick={() => handleRedirect(datas.id)}
                            className="ph ph-caret-right animated-caret dashboard_arrow"
                            style={{ fontSize: "x-large" }}
                          ></i>
                        </span>
                      </div>
                      <div className="flex-align gap-8 d-flex justify-content-between w-100 p-16 bg-light-grey rounded-16 mb-2">
                        <span className="text-sm text-white">
                          <p className="text-black">Order Status</p>
                          <p className="text-black">
                            <b>
                              {capitalizeFirstLetter(datas?.status)}{" "}
                              {new Date(datas?.created_at)
                                .toLocaleDateString("en-GB")
                                .replace(/\//g, ".")}
                            </b>
                          </p>
                        </span>
                        <span className="text-sm text-main-two-600">
                          <p className="text-black">Estimated Delivery</p>
                          <p className="text-black">
                            {(datas?.delivery_date &&
                              new Date(datas?.delivery_date)
                                .toLocaleDateString("en-GB")
                                .replace(/\//g, ".")) ||
                              "-"}
                          </p>
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {/* grid for savings */}
          <div className="col-sm-6">
            <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
              <div className="py-xl-4">
                <h4 className="text-blue mb-8">Total Savings</h4>

                <div>
                  <div className="bg-light-grey flex-align gap-4 d-flex justify-content-between w-50 p-22  rounded-16 mb-20">
                    <span className="text-sm text-white">
                      <p className="text-black">This year so far</p>
                      <h3 className="total_color">
                        {dashboard?.page?.data?.total_discount_sum === 0 ||
                        dashboard?.page?.data?.total_discount_sum === null
                          ? "0.00"
                          : dashboard?.page?.data?.total_discount_sum}
                      </h3>

                      <p className="center total_color">
                        <b>{user?.user_data?.company?.currency?.value}</b>
                      </p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <br></br>
            <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-22">
              <div className="py-xl-4">
                <h4 className="text-blue mb-8">Credit Limit</h4>

                {limit === 0 ? (
                  <p className="text-black mb-8">
                    Your company does not have a credit agreement with Dhofar
                    Global.
                  </p>
                ) : progress > 75 ? (
                  <p className="text-black mb-8">
                    You have almost used your credit limit!
                  </p>
                ) : progress > 0 ? (
                  <p className="text-black mb-8">
                    Your company used credit and credit limit.
                  </p>
                ) : null}

                {progress > 0 ? (
                  <div className="mt-12">
                    <div
                      className="progress w-100 bg-color-three rounded-pill h-8"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={50}
                      aria-valuemin={70}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar  rounded-pill"
                        style={{ width: `${progress}%`, background: "#dd4949" }} // Increase the percentage here
                      />
                    </div>

                    {/* Span container for left & right alignment */}
                    <div className="d-flex justify-content-between w-100 mt-8">
                      <span className="text-gray-900 text-s fw-medium">
                        Used
                        <br /> {user?.user_data?.company?.currency?.value}{" "}
                        {usedSoFar}
                      </span>
                      <span className="text-gray-900 text-s fw-medium">
                        Limit
                        <br /> {user?.user_data?.company?.currency?.value}{" "}
                        {limit}
                      </span>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* grid for componants */}
          <div className="col-sm-6">
            <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
              <div className="py-xl-4">
                <h4 className="text-blue ack mb-8">
                  Products ordered with regular prices
                </h4>
                {special_products && special_products.length > 0 ? (
                  <p>
                    You order these products regularly, but don't have special
                    price for them. Why not request a quote?
                  </p>
                ) : (
                  <p>There are no products to display yet.</p>
                )}
                <div className="col-xxl-12 col-lg-12 col-sm-6">
                  <div className="p-16  rounded-16 position-relative transition-2 ">
                    <div className="short-product-list arrow-style-two">
                      <div>
                        {special_products &&
                          special_products?.length > 0 &&
                          special_products.map((data, index) => (
                            <>
                              {" "}
                              {/* React Fragment */}
                              <div
                                key={index}
                                className="border border-gray-100 hover:border-main-600 grid grid-cols-4 items-center gap-4 p-4"
                              >
                                {/* Image Column */}
                                <div className="flex-shrink-0">
                                  <img
                                    src={
                                      data?.images?.[0]?.files?.small?.url ||
                                      "default-image.jpg"
                                    }
                                    alt=""
                                    className="w-50 h-70 object-cover"
                                  />
                                </div>

                                {/* Name Column */}
                                <div className="min-w-0">
                                  <h6 className="text-lg font-semibold truncate">
                                    {data?.name}
                                  </h6>
                                  <span className="text-heading text-md block truncate">
                                    {data?.brand?.[0]?.name}
                                  </span>
                                </div>

                                {/* Price Column (Aligned to Right) */}
                                <div className="text-right">
                                  <h6 className="text-blue font-semibold whitespace-nowrap">
                                    {user?.user_data?.company?.currency?.value}{" "}
                                    {data?.min_base_gross_price?.toFixed(
                                      currency === "OMR" ? 3 : 2
                                    )}
                                  </h6>
                                </div>
                              </div>
                              <br />
                            </>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
